<div
    class="backdrop"
    [ngClass]="{ 'backdrop-modal-backdrop': modalBackdrop }"
    *ngIf="visible"
    (click)="backdropClickEvent.emit()"
    @fadeIn
></div>
